import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/components/v-form-render.vue'
wx.createComponent(Component)